(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider
        .state('visualizacao', {
            abstract: true,
            url: "/membro/validacao/relatorio",
            templateUrl: "module/validacao/visualizacao/visualizacao.html",
            controller: 'VisualizacaoRelatorio',
            controllerAs: 'vm',
            params: {
              periodoSelecionado: '',
              nomeOrgaoFiltrado: '',
              promotorSelecionado: '',
              relDkSelecionado:'',
              situacaoSelecionada:''
            }
          }).state('visualizacao.atuacao', {
            url: "/atuacao/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.extrajudicial', {
            url: "/extrajudicial/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.judicial.naocriminal', {
            url: "/judicial-naocriminal/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.extrajudicial.naocriminal', {
            url: "/extrajudicial-naocriminal/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.preprocessual', {
            url: "/preprocessual/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.processual', {
            url: "/processual/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.judicial', {
            url: "/judicial/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.criminal', {
            url: "/criminal/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.eleitoral', {
            url: "/eleitoral/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.ciencias', {
            url: "/ciencias/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.recursos', {
            url: "/recursos/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.outros', {
            url: "/outros/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.emnomedopai', {
            url: "/emnomedopai/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.averiguacoesoficiosas', {
            url: "/averiguacoesoficiosas/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        })
    ;
  }

})();
